/**
 * What /link-error shows: the generic description only when a specific
 * reason replaced it (no duplicate paragraph), and the sign-in hint only
 * for visitors who are not signed in (DEV-543).
 */
export function resolveLinkErrorView({
  reasonMessage,
  description,
  isSignedIn,
}: {
  reasonMessage: string | undefined;
  description: string | undefined;
  isSignedIn: boolean;
}): {
  primary: string;
  secondary: string | null;
  showSignIn: boolean;
} {
  const primary = reasonMessage || description || '';
  const secondary = description && description !== primary ? description : null;
  return { primary, secondary, showSignIn: !isSignedIn };
}
